
import React from 'react';
import { Mic } from 'lucide-react';
import SolutionCard from './cards/SolutionCard';
import AudioPlayer from '@/components/AudioPlayer';

const VoiceTechnology = () => {
  return (
    <SolutionCard
      icon={Mic}
      title="Voice Agents"
      subtitle="Voice Latency Comparison"
      description="Compare our low-latency voice processing against traditional processing"
    >
      <div className="space-y-6 pt-2">
        <div className="grid md:grid-cols-2 gap-6">
          <div className="space-y-2">
            <AudioPlayer 
              src="/voice-latency-demo.mp3" 
              title="Enhanced Low-Latency Voice" 
              className="border-primary/30 hover:border-primary/50 transition-colors" 
            />
          </div>
          <div className="space-y-2">
            <AudioPlayer 
              src="/traditional-voice-processing.mp3" 
              title="Standard Voice Processing" 
              className="border-muted hover:border-muted/80 transition-colors" 
            />
          </div>
        </div>
        <div className="bg-secondary/30 hover:bg-secondary/40 transition-colors rounded-lg p-4 pb-2">
          <p className="text-sm">
            <strong>Notice the difference:</strong> Our low-latency solution provides near-instantaneous response times,
            making voice interactions feel natural and seamless. Traditional processing creates noticeable delays that
            disrupt the user experience.
          </p>
        </div>
      </div>
    </SolutionCard>
  );
};

export default VoiceTechnology;
